const o=(o,t)=>`${o}.${t}`;export{o as getCookieChunkName};
